"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_tv__primetime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a07d6236-ad35-45d0-96b4-aceff9e8d5e9",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-1{stroke:#333;stroke-linecap:round;stroke-miterlimit:10;stroke-width:8px;}")), /*#__PURE__*/React.createElement("title", null, "tv-primetime"), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 59.82,
    y1: 163.76,
    x2: 43.82,
    y2: 83.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 80,
    y1: 163.19,
    x2: 75,
    y2: 130.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 96,
    y1: 163.19,
    x2: 96,
    y2: 130.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 112,
    y1: 163.19,
    x2: 117,
    y2: 130.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 131.82,
    y1: 163.76,
    x2: 147.82,
    y2: 83.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 59.82,
    y1: 163.76,
    x2: 131.82,
    y2: 163.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 43.82,
    y1: 83.76,
    x2: 146.82,
    y2: 83.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 71,
    y1: 108.12,
    x2: 68,
    y2: 83.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 96,
    y1: 108.12,
    x2: 96,
    y2: 83.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 121,
    y1: 108.12,
    x2: 124,
    y2: 83.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73,61c0-7.73-3.27-14-11-14A14,14,0,0,0,48,60.58C42.23,62.3,36.49,67.83,38,74c1.83,7.5,3.17,9.83,9,10",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145,84h1.07c7.73,0,9.93-6.27,9.93-14a14,14,0,0,0-9.61-13.29,11,11,0,0,0-18.73-11.55,10.79,10.79,0,0,0-.85,1.7A14,14,0,0,0,108,60h0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126,43c-5.54-4.7-10.6-6.59-18.35-7a14,14,0,0,0-26,10.22A33.85,33.85,0,0,0,72,70c0,5,1.07,6.74,3,11",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 192,
    height: 192
  }));
}

var _default = ic_tv__primetime;
exports.default = _default;